export var STAFF_SETTINGS_LIMITS = {
    attritionPct: { min: 0, max: 100 },
    graduationPct: { min: 1, max: 100 },
    recruitingLeadTimeWeeks: { min: 1, max: 52 },
    classSize: { min: 1, max: 10000 },
    paidHoursPerDay: { min: 0.5, max: 24 },
    workingDaysPerWeek: { min: 1, max: 7 },
    workingDaysPerYear: { min: 1, max: 365 },
};
var parseNum = function (value) {
    var n = Number.parseFloat(value);
    return Number.isFinite(n) ? n : null;
};
var clamp = function (n, min, max) { return Math.min(max, Math.max(min, n)); };
export var clampWorkHoursFormValue = function (field, raw) {
    var n = parseNum(raw);
    if (n === null)
        return raw;
    switch (field) {
        case 'paidHoursPerDay':
            return String(clamp(n, STAFF_SETTINGS_LIMITS.paidHoursPerDay.min, STAFF_SETTINGS_LIMITS.paidHoursPerDay.max));
        case 'workingDaysPerWeek':
            return String(clamp(n, STAFF_SETTINGS_LIMITS.workingDaysPerWeek.min, STAFF_SETTINGS_LIMITS.workingDaysPerWeek.max));
        case 'workingDaysPerYear':
            return String(clamp(n, STAFF_SETTINGS_LIMITS.workingDaysPerYear.min, STAFF_SETTINGS_LIMITS.workingDaysPerYear.max));
        default:
            return raw;
    }
};
export var mapLoadedWorkHoursToForm = function (wh) { return ({
    paidHoursPerDay: wh.paidHoursPerDay > 0 ? String(clamp(wh.paidHoursPerDay, 0.01, STAFF_SETTINGS_LIMITS.paidHoursPerDay.max)) : '',
    workingDaysPerWeek: wh.workingDaysPerWeek > 0
        ? String(clamp(wh.workingDaysPerWeek, STAFF_SETTINGS_LIMITS.workingDaysPerWeek.min, STAFF_SETTINGS_LIMITS.workingDaysPerWeek.max))
        : '',
    workingDaysPerYear: wh.workingDaysPerYear > 0
        ? String(clamp(wh.workingDaysPerYear, STAFF_SETTINGS_LIMITS.workingDaysPerYear.min, STAFF_SETTINGS_LIMITS.workingDaysPerYear.max))
        : '',
}); };
var workHoursFormError = function (wh, t, sectionLabel) {
    var day = parseNum(wh.paidHoursPerDay);
    var week = parseNum(wh.workingDaysPerWeek);
    var year = parseNum(wh.workingDaysPerYear);
    if (day !== null &&
        (day < STAFF_SETTINGS_LIMITS.paidHoursPerDay.min || day > STAFF_SETTINGS_LIMITS.paidHoursPerDay.max)) {
        return t('errors.paidHoursPerDayRange', {
            defaultValue: '{{section}}: Paid hours per day must be between 0.50 and 24.',
        }).replace('{{section}}', sectionLabel);
    }
    if (week !== null &&
        (week < STAFF_SETTINGS_LIMITS.workingDaysPerWeek.min || week > STAFF_SETTINGS_LIMITS.workingDaysPerWeek.max)) {
        return t('errors.workingDaysPerWeekRange', {
            defaultValue: '{{section}}: Working days per week must be between 1 and 7.',
        }).replace('{{section}}', sectionLabel);
    }
    if (year !== null &&
        (year < STAFF_SETTINGS_LIMITS.workingDaysPerYear.min || year > STAFF_SETTINGS_LIMITS.workingDaysPerYear.max)) {
        return t('errors.workingDaysPerYearRange', {
            defaultValue: '{{section}}: Working days per year must be between 1 and 365.',
        }).replace('{{section}}', sectionLabel);
    }
    return null;
};
export var getStaffSettingsFormError = function (form, t) {
    var _a;
    var attritionPct = STAFF_SETTINGS_LIMITS.attritionPct, graduationPct = STAFF_SETTINGS_LIMITS.graduationPct, recruiting = STAFF_SETTINGS_LIMITS.recruitingLeadTimeWeeks, classSizeLimits = STAFF_SETTINGS_LIMITS.classSize;
    var weekly = parseNum(form.avgWeeklyAttrition);
    var monthly = parseNum(form.avgMonthlyAttrition);
    var grad = parseNum(form.graduationRate);
    var lead = parseNum(form.recruitingLeadTimeWeeks);
    var cls = parseNum(form.classSize);
    if (weekly !== null && (weekly < attritionPct.min || weekly > attritionPct.max)) {
        return t('errors.attritionRange', { defaultValue: 'Attrition percentages must be between 0 and 100.' });
    }
    if (monthly !== null && (monthly < attritionPct.min || monthly > attritionPct.max)) {
        return t('errors.attritionRange', { defaultValue: 'Attrition percentages must be between 0 and 100.' });
    }
    if (grad !== null && (grad < graduationPct.min || grad > graduationPct.max)) {
        return t('errors.graduationRange', { defaultValue: 'Graduation rate must be between 1 and 100.' });
    }
    if (lead !== null && (lead < recruiting.min || lead > recruiting.max)) {
        return t('errors.recruitingLeadTimeRange', {
            defaultValue: 'Recruiting lead time must be between 1 and 52 weeks.',
        });
    }
    if (cls !== null && (cls < classSizeLimits.min || cls > classSizeLimits.max)) {
        return t('errors.classSizeRange', {
            defaultValue: 'Class size must be between 1 and 10000.',
        });
    }
    return ((_a = workHoursFormError(form.agent, t, t('agentWorkHours', { defaultValue: 'Agents' }))) !== null && _a !== void 0 ? _a : workHoursFormError(form.support, t, t('supportWorkHours', { defaultValue: 'Support staff' })));
};
export var staffSettingsFormToPayload = function (form) {
    var toNum = function (v) {
        var n = Number.parseFloat(v);
        return Number.isFinite(n) ? n : null;
    };
    var toInt = function (v, min, max) {
        var n = Math.floor(Number.parseFloat(v));
        return Number.isFinite(n) ? clamp(n, min, max) : 0;
    };
    var toRoundedIntOrNull = function (v) {
        var n = Number.parseFloat(v);
        return Number.isFinite(n) ? Math.round(n) : null;
    };
    var paidHoursPerDay = STAFF_SETTINGS_LIMITS.paidHoursPerDay, workingDaysPerWeek = STAFF_SETTINGS_LIMITS.workingDaysPerWeek, workingDaysPerYear = STAFF_SETTINGS_LIMITS.workingDaysPerYear;
    var workHoursPayload = function (wh) {
        var _a;
        return ({
            paidHoursPerDay: clamp((_a = toNum(wh.paidHoursPerDay)) !== null && _a !== void 0 ? _a : 0, 0, paidHoursPerDay.max),
            workingDaysPerWeek: toInt(wh.workingDaysPerWeek, workingDaysPerWeek.min, workingDaysPerWeek.max),
            workingDaysPerYear: toInt(wh.workingDaysPerYear, workingDaysPerYear.min, workingDaysPerYear.max),
        });
    };
    return {
        avgWeeklyAttrition: toNum(form.avgWeeklyAttrition),
        avgMonthlyAttrition: toNum(form.avgMonthlyAttrition),
        graduationRate: toNum(form.graduationRate),
        recruitingLeadTimeWeeks: toRoundedIntOrNull(form.recruitingLeadTimeWeeks),
        classSize: toNum(form.classSize),
        agent: workHoursPayload(form.agent),
        support: workHoursPayload(form.support),
    };
};
